jQuery(document).ready(function ($) {
    var mainSearch = $("#mainsearch");
    var overlay = $("#searchbar-overlay");
    var navbar = $(".region-navbar.page-navbar");
    var inertNavbarElements = [];

    // once the user opens search, scrolling manages the overlay: it closes when
    // its resting spot scrolls out of view and reopens when it scrolls back.
    // closing by hand (X or Escape) opts out until the user opens it again.
    var scrollManaged = false;

    // disable only navbar controls obscured by the search overlay
    function setNavbarInert(isInert) {
        if (isInert) {
            if (inertNavbarElements.length) return;

            navbar.each(function () {
                if (!this.hasAttribute("inert")) {
                    this.setAttribute("inert", "");
                    inertNavbarElements.push(this);
                }
            });
        } else {
            inertNavbarElements.forEach(function (element) {
                element.removeAttribute("inert");
            });
            inertNavbarElements = [];
        }
    }

    // keep the off-screen overlay out of the tab order and accessibility tree.
    // scroll-driven open/close passes instant=true so it doesn't replay the flip
    // animation, that is reserved for the deliberate open from the search button
    function setOverlayOpen(isOpen, instant) {
        if (instant && overlay.length) {
            overlay[0].style.transition = "none";
            window.requestAnimationFrame(function () {
                window.requestAnimationFrame(function () {
                    overlay[0].style.transition = "";
                });
            });
        }

        overlay.toggleClass("active", isOpen);
        mainSearch.attr("aria-expanded", isOpen ? "true" : "false");

        if (isOpen) {
            overlay.removeAttr("inert");
            setNavbarInert(true);
        } else {
            setNavbarInert(false);
            overlay.attr("inert", "");
        }
    }

    mainSearch.attr("aria-controls", "searchbar-overlay");
    // the overlay can load already open (e.g. arriving at the catalogue from a
    // search), so treat that as scroll-managed too, otherwise scrolling would
    // leave the navbar inert and trapped
    var overlayStartsOpen = overlay.hasClass("active");
    setOverlayOpen(overlayStartsOpen);
    scrollManaged = overlayStartsOpen;

    // the sticky navbar stays pinned while the absolutely-positioned overlay
    // scrolls off, which would otherwise leave the navbar buttons inert and dead.
    // a marker at the overlay's resting position scrolls with the page (unlike
    // the sticky navbar), so watching it lets us close the overlay as that spot
    // leaves the viewport and reopen it as the user scrolls back up to it.
    if (overlay.length && "IntersectionObserver" in window) {
        var sentinel = document.createElement("div");
        sentinel.setAttribute("aria-hidden", "true");
        sentinel.style.cssText =
            "position:absolute;top:0;left:0;width:1px;pointer-events:none;visibility:hidden;";
        sentinel.style.height = overlay[0].offsetHeight + "px";
        overlay[0].parentNode.insertBefore(sentinel, overlay[0]);

        new IntersectionObserver(
            function (entries) {
                if (!scrollManaged) return;

                var visible = entries[entries.length - 1].isIntersecting;
                if (visible && !overlay.hasClass("active")) {
                    setOverlayOpen(true, true);
                } else if (!visible && overlay.hasClass("active")) {
                    setOverlayOpen(false, true);
                }
            },
            { threshold: 0 }
        ).observe(sentinel);
    }

    $("#mainsearch").on("click", function (e) {
        e.preventDefault();

        if (!overlay.length) return;
        var overlayElement = overlay[0];

        if (isElementInViewport(overlayElement) && overlay.hasClass("active")) {
            // if open and in viewport, close it (and stop managing it on scroll)
            setOverlayOpen(false);
            scrollManaged = false;
            return;
        } else if (overlay.hasClass("active")) {
            // scroll to the searchbar if it's not in the viewport
            overlayElement.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
            // open the searchbar and let scrolling manage it from here
            setOverlayOpen(true);
            scrollManaged = true;
            overlayElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        // focus the input field without scrolling the page (if supported by the browser)
        var input = $("#query-input").get(0);
        if (!input) return;

        try {
            input.focus({ preventScroll: true });
        } catch (e) {
            input.focus();
        }
    });

    $("#search-close").on("click", function (e) {
        e.preventDefault();
        setOverlayOpen(false);
        scrollManaged = false;
        mainSearch.trigger("focus");
    });

    // react only while this overlay is open, leaving other Escape handlers alone
    $(document).on("keydown.searchbar", function (e) {
        if (e.key !== "Escape" || !overlay.hasClass("active")) return;

        setOverlayOpen(false);
        scrollManaged = false;
        mainSearch.trigger("focus");
    });
});

// Source - https://stackoverflow.com/a/7557433
// Posted by Dan, modified by community. See post 'Timeline' for change history
// Retrieved 2026-03-31, License - CC BY-SA 4.0

function isElementInViewport (el) {
    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
}
